import { observable } from 'mobx';
import Patient from './Patient';
import API from 'api';

export default class ItemInfor {
	@observable id: number;
	@observable therapeuticArea: string = '';
	@observable therapeuticAreaID: number;
	@observable itemName: string = '';
	@observable itemDescription: string = '';
	@observable itemCode: string = '';
	@observable restrictionCode: string = '';
	@observable restrictionText: string = '';
	@observable initial: boolean;
	@observable treatment: string = '';
	@observable indication: string = '';
	@observable noOfRepeats: number;
	@observable increaseRepeats: number;
	@observable unit: number;
	@observable maxQuantityPacks: number;
	@observable maxQuantityUnits: number;
	@observable quantity: number;
	@observable private: boolean;
	@observable api: boolean;
	@observable disabled: boolean;

	constructor(data: JSON = null) {
		if (data) this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	static loadById = async (id: number): Promise<ItemInfor> => {
		let res = await API.get(`/ItemInfors/${id}`);
		return new ItemInfor(res);
	};

	static fetchMoreByAreaIndication = async (
		areaId: number,
		indication: string
	): Promise<Array<ItemInfor>> => {
		return await API.get(
			`/ItemInfors?filter=${JSON.stringify({
				where: {
					and: [{ indication: indication }, { therapeuticAreaID: areaId }, { disabled: false }]
				},
				fields: [
					'id',
					'restrictionText',
					'increaseRepeats',
					'unit',
					'maxQuantityPacks',
					'maxQuantityUnits'
				]
			})}`
		);
	};
}



// WEBPACK FOOTER //
// ./src/stores/ItemInfor.js